import { IconButton } from '@material-ui/core'
import Loading from 'components/Global/Loading'
import React from 'react'
import { FaPlusCircle, FaRegTimesCircle } from 'react-icons/fa'
import { useQuery } from '@apollo/client'

import BaseBin from '../../BaseBin'
import CreateTypes from '../Forms/CreateTypes'
import { Q_MATERIAL_TYPE } from 'graphql/query'
import NoContents from 'components/Global/NoContents'

interface MatTypes {
  name: string
  roughnesMap: string
  metalness: number
  roughnesIntensity: number
  normalMap: string
  normalIntensity: number
  normalu: number
  normalv: number
  details: string
}

const MaterialTypes = () => {
  const { refetch } = useQuery(Q_MATERIAL_TYPE)

  const [create, setCreate] = React.useState<boolean>(false)
  const [mTypes, setMTypes] = React.useState<MatTypes[]>([])
  const [loading, setLoading] = React.useState(true)
  const [noContents, setNoContents] = React.useState<boolean>(false)

  const update = () => {
    setLoading(true)
    refetch() &&
      refetch().then(res => {
        setMTypes(res.data.rMaterialType)
        res.data.rMaterialType.length == 0
          ? setNoContents(true)
          : setNoContents(false)
        setLoading(false)
      })
  }

  const handleClose = () => {
    setCreate(false)
    update()
  }

  React.useEffect(() => {
    update()
  }, [refetch])

  return (
    <BaseBin
      title="Material Types"
      errors={null}
      actions={[
        <IconButton
          color="primary"
          onClick={() => setCreate(create ? false : true)}
        >
          {!create ? <FaPlusCircle /> : <FaRegTimesCircle />}
        </IconButton>,
      ]}
    >
      {create ? (
        <CreateTypes handleClose={handleClose} />
      ) : loading ? (
        <Loading />
      ) : noContents ? (
        <NoContents />
      ) : (
        <div style={{ display: 'flex' }}>
          {mTypes.map((mType, i) => {
            return (
              <div
                key={i}
                style={{
                  width: '150px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '150px',
                  backgroundColor: '#fafafa1a',
                  margin: '1rem',
                  borderRadius: '4px',
                }}
              >
                {mType.name}
              </div>
            )
          })}
        </div>
      )}
    </BaseBin>
  )
}

export default MaterialTypes
